import { createSlice } from '@reduxjs/toolkit';
import { type CustomerNotificationPreference } from 'api/pushNotificationPreference.api';

export interface PushNotificationPreferenceState {
  preferences: CustomerNotificationPreference[];
}

const initialState: PushNotificationPreferenceState = {
  preferences: [],
};

export const pushNotificationPreferenceSlice = createSlice({
  name: 'pushNotificationPreferences',
  initialState,
  reducers: {
    setPreferences(state, { payload }) {
      state.preferences = payload;
    },

    updatePreference(state, { payload }) {
      const preference = state.preferences.find(
        (p) => p.customerId === payload.customerId
      );
      if (preference) {
        preference.tpmsAlertsEnabled = payload.tpmsAlertsEnabled;
      }
    },

    resetPushNotificationPreferenceState() {
      return { preferences: [] };
    },
  },
});

export const {
  setPreferences,
  updatePreference,
  resetPushNotificationPreferenceState,
} = pushNotificationPreferenceSlice.actions;
export default pushNotificationPreferenceSlice.reducer;
